var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title" }, [_vm._v(" 个人资料 ")]),
    _c("div", { staticClass: "info-box" }, [
      _c("div", { staticClass: "info-label" }, [_vm._v("头像")]),
      _c("div", { staticClass: "info-content" }, [
        _c("div", { staticClass: "avatar" }, [
          _vm.userInfo.avatar
            ? _c("img", {
                attrs: {
                  src: _vm.userInfo.avatar,
                  width: "100%",
                  height: "100%",
                },
              })
            : _c("img", {
                staticStyle: { "margin-left": "-15px" },
                attrs: {
                  src: require("@/static/login/avatar.png"),
                  width: "100%",
                  height: "100%",
                },
              }),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "info-box" }, [
      _c("div", { staticClass: "info-label" }, [_vm._v("用户名")]),
      _c("div", { staticClass: "info-content" }, [
        _vm._v(_vm._s(_vm.userInfo.username)),
      ]),
    ]),
    _c("div", { staticClass: "info-box" }, [
      _c("div", { staticClass: "info-label" }, [_vm._v("手机号码")]),
      _c("div", { staticClass: "info-content" }, [
        _vm._v(_vm._s(_vm.userInfo.phone)),
      ]),
    ]),
    _c("div", { staticClass: "info-box" }, [
      _c("div", { staticClass: "info-label" }, [_vm._v("所属角色")]),
      _c(
        "div",
        {
          staticClass: "info-content",
          staticStyle: { "margin-bottom": "-5px" },
        },
        _vm._l(_vm.roleList, function (item) {
          return _c(
            "el-tag",
            {
              key: item.id,
              staticStyle: { "margin-right": "8px", "margin-bottom": "5px" },
              attrs: { size: "mini" },
            },
            [_vm._v(_vm._s(item.name))]
          )
        }),
        1
      ),
    ]),
    _c("div", { staticClass: "info-box" }, [
      _c("div", { staticClass: "info-label" }, [_vm._v("创建日期")]),
      _c("div", { staticClass: "info-content" }, [
        _vm._v(_vm._s(_vm.userInfo.createTime)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }